import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import OnewayPickupPeriodicHikeTimeServices from "services/OnewayPickupPeriodicHikeTimeServices";
import { notifyError, notifySuccess } from "utils/toast";
import CityServices from "services/CityServices";

const useOnewayPickupPeriodicHikeTimeSubmit = (id) => {

  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [selectedCity, setSelectedCity] = useState(null);
  const [fromCity, setfromCity] = useState(null);
  const [toCity, settoCity] = useState(null);
  const [dataInput, setDataInput] = useState([]);
  const [open, setOpen] = useState(false);
  const [cities, setCities] = useState([]);


  const [startTimeOptions, setStartTimeOptions] = useState([]);
  const [loading, setLoading] = useState(false);

useEffect(() => {
  async function fetchCities() {
    const res = await CityServices.getAllCity();
    setCities(
      res.data.map(c => ({
        value: c.id_city,
        label: c.name.trim()
      }))
    );
  }
  fetchCities();
}, []);

const getCityIdByName = (name) => {
  if (!name) return null;
  const city = cities.find(
    c => c.label.toLowerCase() === name.toLowerCase()
  );
  return city ? city.value : null;
};

  const generateTimeOptions = () => {
    const options = [];
    const minutes = ['00', '30'];
    const periods = ['AM', 'PM'];

    for (let period of periods) {
      for (let hour = 0; hour <= 11; hour++) {
        for (let minute of minutes) {
          options.push(`${hour === 0 ? 12 : hour}:${minute} ${period}`);
        }
      }
    }

    return options;
  };


  useEffect(() => {
    const options = generateTimeOptions();
    setStartTimeOptions(options);
    setDataInput((prevData) => [
      ...prevData,
      {
        [`start_time_${prevData.length}`]: '12:00 AM',
        [`end_time_${prevData.length}`]: '12:30 AM',
        ['vehicle_type_' + (prevData.length)]: [],
        ['hike_' + (prevData.length)]: "",
        ['endTimeOptions_' + (prevData.length)]: options.slice(1)
      }
    ]);
  }, []);


  useEffect(() => {
  }, [dataInput]);
  const handleStartTimeChange = (e, i, oldindex) => {
    const { value } = e.target;
    setDataInput(prevDataInput => {
      return prevDataInput.map((row, index) => {
        if (index === oldindex) {

          const startTimeIndex = startTimeOptions.findIndex(option => option === value);
          const endTimeOptionsForThisRow = startTimeOptions.slice(startTimeIndex + 1); // Start from next option
          return { ...row, [`start_time_${i}`]: value, [`end_time_${i}`]: endTimeOptionsForThisRow[0], [`endTimeOptions_${i}`]: endTimeOptionsForThisRow };
        }
        return row;
      });
    });
  };

  const handleEndTimeChange = (e, i, oldindex) => {
    const { value } = e.target;
    setDataInput(prevDataInput => {
      return prevDataInput.map((row, index) => {
        if (index === oldindex) {
          return { ...row, [`end_time_${i}`]: value };
        }
        return row;
      });
    });
  };

  const {
    trigger,
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();


  const handlefromCityChange = (city_id) => {
    setfromCity(city_id);
    setValue("from_city", city_id);
  };

  const handletoCityChange = (city_id) => {
    settoCity(city_id);
    setValue("to_city", city_id);
  };


  const handleChangeInput = (e, i, names = false) => {
    if (e && e.target) {
      const { name, value } = e.target;
      if (value === '0') {
        return;
      }
      const onChangeVal = [...dataInput];
      onChangeVal[i][name] = value;
      setDataInput(onChangeVal);
    }
    else {
      const onChangeVal = [...dataInput];
      onChangeVal[i][names] = e;
      setDataInput(onChangeVal);
    }
  };
  const handleVehicleCategoryChange = (value, i, name) => {

    // Update the input field
    handleChangeInput(value, i, name);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const hasDuplicateTimes = () => {
        const seenTimes = new Set();

        const convertToMinutes = (time) => {
          const [hourMinute, period] = time.split(' ');
          let [hour, minute] = hourMinute.split(':').map(Number);
          if (period === 'PM' && hour !== 12) hour += 12;
          if (period === 'AM' && hour === 12) hour = 0;
          return hour * 60 + minute;
        };

        for (const slot of dataInput) {
          const keys = Object.keys(slot).filter(key => key.startsWith('start_time_'));

          for (const key of keys) {
            const start_time = slot[key];
            const end_time = slot[key.replace('start_time', 'end_time')];
            const vehicle_key = key.replace('start_time', 'vehicle_type');
            const vehicle_type = slot[vehicle_key]?.[0]?.value;

            const startMinutes = convertToMinutes(start_time);
            const endMinutes = convertToMinutes(end_time);

            for (const seenSlot of seenTimes) {
              const { seenStart, seenEnd, seenVehicleType } = seenSlot;

              if (vehicle_type === seenVehicleType && (
                (startMinutes >= seenStart && startMinutes < seenEnd) ||
                (endMinutes > seenStart && endMinutes <= seenEnd) ||
                (startMinutes <= seenStart && endMinutes >= seenEnd)
              )) {
                return true;
              }
            }

            seenTimes.add({ seenStart: startMinutes, seenEnd: endMinutes, seenVehicleType: vehicle_type });
          }
        }

        return false;
      };
      if (hasDuplicateTimes()) {

        setOpen(true);
        return;
      }
      //console.log(dataInput);
      // return false;
      const startTimeArray = [];
      const endTimeArray = [];
      const hikeArray = [];
      const vehicleTypeArray = [];

      dataInput.forEach((val, i) => {
        Object.keys(val).forEach(key => {
          if (key.startsWith('start_time_')) {
            const index = key.substring('start_time_'.length);
            const endTimeKey = `end_time_${index}`;
            const hikeKey = `hike_${index}`;
            const vehicleArrKey = `vehicle_type_${index}`;
            if (val.hasOwnProperty(endTimeKey)) {
              const startTime = val[key];
              const endTime = val[endTimeKey];
              const Hike = val[hikeKey];
              const VehicleArr = val[vehicleArrKey];
              const VehicleSingleArr = [];
              VehicleArr.forEach((item) => {
                VehicleSingleArr.push(item.value);
              });
              vehicleTypeArray.push(VehicleSingleArr);
              startTimeArray.push(startTime);
              hikeArray.push(Hike);
              endTimeArray.push(endTime);
            }
          }
        });
      });

      const dataValues = {};
      dataValues.vehicle_type = vehicleTypeArray;
      dataValues.hike = hikeArray;
      dataValues.start_time = startTimeArray;
      dataValues.end_time = endTimeArray;
      // dataValues.name_of_airport=cityIds.sort((a, b) => a - b);
      dataValues.from_city = fromCity;
      dataValues.to_city = toCity;

      setIsSubmitting(true);

      if (id) {
        const res = await OnewayPickupPeriodicHikeTimeServices.updateOnewayPickupPeriodicHikeTime(id, dataValues);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await OnewayPickupPeriodicHikeTimeServices.addOnewayPickupPeriodicHikeTime(dataValues);
      
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
      // closeDrawer();
    }
    finally {
      setLoading(false);
    }
  };

  const parsePgArray = (pgArrayString) => {
    if (!pgArrayString) return [];
    return pgArrayString
      .replace(/[{}"]/g, '')
      .split(',')
      .map(item => item.trim());
  };

const getOnewayPickupPeriodicHikeTimeData = async () => {
  try {
    const options = generateTimeOptions();
    setStartTimeOptions(options);

    const res =
      await OnewayPickupPeriodicHikeTimeServices
        .getOnewayPickupPeriodicHikeTimeById(id);


    if (res && res.data) {
      res.data.start_time = parsePgArray(res.data.start_time);
      res.data.end_time = parsePgArray(res.data.end_time);

      const FormWholeArray = [];

      res.data.start_time.forEach((item, index) => {
        const startTimeIndex = options.findIndex(o => o === item);

        FormWholeArray.push({
          [`start_time_${index}`]: item,
          [`end_time_${index}`]: res.data.end_time[index],
          [`endTimeOptions_${index}`]: options.slice(startTimeIndex + 1),
          [`vehicle_type_${index}`]: [{
            value: res.data.vehicles[index].vehicle_type_id, 
            label: res.data.vehicles[index].vehicle_type
          }],
          [`hike_${index}`]: res.data.vehicles[index].hike
        });
      });

      setDataInput(FormWholeArray);

  
      const fromCityId = getCityIdByName(res.data.from_city);
      const toCityId = getCityIdByName(res.data.to_city);

      setfromCity(fromCityId);
      settoCity(toCityId);

      setValue("from_city", fromCityId);
      setValue("to_city", toCityId);
    }
  } catch (err) {
    notifyError(err?.response?.data?.message || err?.message);
  }
};




  useEffect(() => {
    if (!isDrawerOpen) {
      setfromCity(null);
      settoCity(null);
      setDataInput([
        {
          start_time_0: "12:00 AM",
          end_time_0: "12:30 AM",
          vehicle_type_0: [],
          hike_0: "",
          endTimeOptions_0: generateTimeOptions().slice(1)
        }
      ]);
      clearErrors("from_city");
      clearErrors("to_city");
      clearErrors();
      return;
    }

    if (id) {
      getOnewayPickupPeriodicHikeTimeData();
    }
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    onSubmit,
    handlefromCityChange,
    handletoCityChange,
    fromCity,
    toCity,
    trigger,
    errors,
    isSubmitting,
    setDataInput,
    dataInput,
    handleChangeInput,
    handleVehicleCategoryChange,
    handleEndTimeChange,
    handleStartTimeChange,
    startTimeOptions,
    setOpen,
    open,
    loading,
    setLoading,

  };
};

export default useOnewayPickupPeriodicHikeTimeSubmit;
